import axios from "axios"
import API from "./api"
//import { Notification } from 'element-ui';
//import { Loading } from 'element-ui';
import store from '../store/index.js';
import router from "@/router";
import config from "@/config";
import JSONBIG from 'json-bigint'

const instance = axios.create({
    baseURL:config.baseUrl
})

axios.defaults.transformResponse = [data => {
    // 对data（后台的原始数据）进行转换
    return JSONBIG.parse(data)
}]
const HTTP = {};
for(let key in API){
    HTTP[key] = async function(params={},config={},type="json"){
        let newParams = null;
        let jsonBig=false;
        if(type === "json"){
            newParams = params;
            let check=params.convertBigId;
            if(check && check===1){
                jsonBig = true;
            }
        }else{
            const formData = new FormData();
            for(let ke in params){
                formData.append(ke,params[ke]);
            }
            newParams = formData;
        }
        let res = null;
        if(API[key].method === "GET" || API[key].method === "DELETE"){
            res = await instance({
                url:API[key].url,
                method:API[key].method,
                params:newParams,
                headers:config
            })
        }else{
            res = await instance({
                url:API[key].url,
                method:API[key].method,
                data:newParams,
                config:config
            })
        }
        if(res && jsonBig){
          // return JSONBIG.parse(res);
        }
        return res;
    }
}

const FILTER_URL = ['auth/oauth/token','upms/public/validateCode']
instance.interceptors.request.use(config=>{
    /*
    Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0)'
    });

     */
    if(FILTER_URL.indexOf(config.url) === -1){
        const access_token = store.state.base.access_token;
        config.headers.Authorization = 'bearer '+ access_token;
    }
    return config;
},err=>{
   // Loading.service().close();
    /*
    Notification.error({
        title: 'ERR',
        message: '发起请求失败，请稍后重试！'
    })

     */
    return Promise.reject(err);
})

instance.interceptors.response.use(res=>{
    //Loading.service().close();
    if(res.status !== 200){
        /*
        Notification.error({
            title: 'ERR',
            message: res.data.msg
        })

         */
        return Promise.reject(res)
    }else{
        if(res.data.code != "200" && FILTER_URL.indexOf(res.config.url) === -1){
            /*
            Notification.error({
                title: 'ERR',
                message: res.data.msg
            })

             */
            return Promise.reject(res);
        }
        return Promise.resolve(res.data);
    }
},err=>{
    //Loading.service().close();
    if(err.response.data.code === "10005"){
        /*
        Notification.error({
            title: 'ERR',
            message: '登录已过期，请重新登录'
        })

         */
        router.push('/')
        return Promise.reject(err)
    }
    /*
    Notification.error({
        title: 'ERR',
        message: err.response.data.msg
    })*/
    return Promise.reject(err.response);
})

export default HTTP;
